<template>
    <section class="employer-ask-question-section half-cut-bg">
      <AskQuestionEmployer></AskQuestionEmployer>
  </section>
</template>

<script>
/* eslint-disable */
import AskQuestionEmployer from '../common/customer-support/AskQuestion.vue'

export default {
  name: 'AskQuestion',
  components: { AskQuestionEmployer },
  data() {
    return {

    }
  },
  methods: {

  },
  mounted() {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

</style>



// WEBPACK FOOTER //
// src/components/employer/AskQuestion.vue